import { Component, inject } from '@angular/core';
import { AuthService, BrewersUnitOfWork } from 'app/core/core.module';
import { ProductLocation } from 'app/core/model/product-location';
import { Subject } from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-product-location-dialog',
    template: `
        <div class="modal-header">
            <h4 class="modal-title">{{ isNew ? 'Enter New' : 'Edit' }} Product Location</h4>
        </div>
        <div class="modal-body" (keyup.esc)="cancel()">
            <dx-form [formData]="location">
                <dxi-item dataField="name"></dxi-item>
                <dxi-item dataField="scaleCode"></dxi-item>
                <dxi-item dataField="trackInventory" editorType="dxCheckBox"></dxi-item>
            </dx-form>
        </div>
        <div class="modal-footer">
            <button class="btn btn-success" (click)="save()">Save</button>
            <button class="btn btn-light" (click)="cancel()">Cancel</button>
        </div>
    `,
    styles: [``],
})
export class ProductLocationDialogComponent {
    uow = inject(BrewersUnitOfWork);
    auth = inject(AuthService);

    result = new Subject<{ success: boolean; value?: ProductLocation }>();
    location: ProductLocation;
    isNew: boolean;
    units = ['Weight', 'Volume', 'Quantity'];
    unit: string;

    ngOnInit() {
        if (!this.location) {
            this.isNew = true;
            this.location = this.uow.productLocations.createEntity({
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
            });
        }
    }

    save() {
        this.result.next({ success: true, value: this.location });
    }

    cancel() {
        this.result.next({ success: false });
    }
}
